import { GetLoansRes } from '@dealstack/shared/lib/generated';
import { LONG_DASH } from '@dealstack/frontend/shared/other/react/specialSigns';
import { InvestorLoanRow } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Investors/InvestorDetailsV2/components/LoansCard/investorLoans.types.ts';

export const mapLoansToRows = (loans: GetLoansRes[] | undefined): InvestorLoanRow[] =>
	(loans ?? []).map((loan) => ({
		// One loan can be funded by several people, so the security alone would not be unique.
		id: `${loan.id}-${loan.funderId}`,
		name: loan.name,
		loanType: loan.type,
		funderId: loan.funderId,
		funderName: loan.funder || LONG_DASH,
		issuerName: loan.issuerName ?? LONG_DASH,
		isViaVehicle: !!loan.isViaVehicle,
		amount: loan.totalValue,
		currency: loan.currency,
	}));

/**
 * The single funding person to link to, or null when the loans come from several — the ticket
 * hides the link rather than guessing which holdings page to open.
 */
export const getSingleFunderId = (rows: InvestorLoanRow[]): string | null => {
	const funderIds = new Set(rows.map((row) => row.funderId));

	return funderIds.size === 1 ? rows[0]?.funderId ?? null : null;
};
